document.querySelector('img.slide__image').setAttribute( 'sizes', '(min-width: 750px) 100vw, 100vw');

document.addEventListener('DOMContentLoaded', () => {

  function fixFirstSlideshowImage() {
    if (window.innerWidth > 749) return;

    document.querySelectorAll('slideshow-component').forEach(slideshow => {

      const firstSlide = slideshow.querySelector('slideshow-slide:first-child');
      const container = firstSlide?.querySelector('.slide__image-container');
      const image = firstSlide?.querySelector('.slide__image');

      if (!container || !image) return;

      const setCorrectHeight = () => {
        if (!image.naturalWidth || !image.naturalHeight) return;

        const width = container.getBoundingClientRect().width;

        container.style.height =
          `${width * (image.naturalHeight / image.naturalWidth)}px`;
      };

      if (image.complete) {
        setCorrectHeight();
      } else {
        image.addEventListener('load', setCorrectHeight, { once: true });
      }

      window.addEventListener('resize', setCorrectHeight);
    });
  }

  fixFirstSlideshowImage();

});